import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ThreadActivityLog = NonNullable<
  ResultOf<typeof threadActivityQuery>["activityLogs"]
>["data"][number];

export const threadActivityQuery = graphql(`
  query ThreadActivity(
    $first: Int!
    $where: QueryActivityLogsWhereWhereConditions
    $orderBy: [QueryActivityLogsOrderByOrderByClause!]
  ) {
    activityLogs(first: $first, where: $where, orderBy: $orderBy) {
      data {
        id
        event
        description
        created_at
        causer {
          id
          name
        }
      }
    }
  }
`);
